
const isTrialPromoType = (promoCode = '') => {
  if (!promoCode) return false

  const TRIAL = 'trial'
  return promoCode.toLowerCase().includes(TRIAL)
}

export default isTrialPromoType